import Conversion from './conversion'
import IntercomSDK from '@intercom/messenger-js-sdk'

export default class Intercom extends Conversion {
  async install () {
    // Install intercom after 10 seconds
    // keep in mind before implementing the events
    setTimeout(() => {
      this.intercom = IntercomSDK({
        app_id: 'lpg0pze2',
      })
    }, 10000)
  }

  push () {}
  defer () {}
  processDeferred () {}

  static _log_name = 'INTERCOM'
}
